export default __webpack_public_path__ + "static/media/David Dia.f78e50b7.jpg";